import script from "./DataEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataEdit.vue?vue&type=script&setup=true&lang=ts"

import "./DataEdit.vue?vue&type=style&index=0&id=2e78ac34&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e78ac34"]])

export default __exports__